<template lang="pug">
.jumbotron.jumbotron-fluid.text-white.bg-dark.mb-0(
  v-if="banner.photo",
  :style="{ backgroundImage: 'url(' + banner.photo.image + ')' }"
)
  .container
    .title.p-3.col-md-9
      h4.display-4.text-white {{ banner.title }}
      p {{ banner.desc }}
</template>

<script>
export default {
  name: "Banner",
  props: {
    banner: Object,
  },
};
</script>

<style lang="scss" scoped>
</style>
